import { Component, computed, inject, signal } from '@angular/core';
import { ConfirmationModalComponent } from "../../../../shared/popups/confirmation-modal/confirmation-modal/confirmation-modal.component";
import { PerformLogService } from '../perform-log.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-perform-log-delete-modal',
  imports: [ConfirmationModalComponent],
  templateUrl: './perform-log-delete-modal.component.html',
  styleUrl: './perform-log-delete-modal.component.scss'
})
export class PerformLogDeleteModalComponent {
  logID = signal(null);
  analyticsService = inject(AnalyticsService);

  performLogService = inject(PerformLogService);
  request$ = computed(() => this.performLogService.deletePerformLog(this.logID()).pipe(
    tap(() => this.analyticsService.track("PR-performnote-delete", {
      logID: this.logID(),
    }))
  ))
}
